const $ = jQuery.noConflict()

var self = module.exports = {
  options: {
    trigger: '',
    panel: '',
    content: ''
  },

  init: function(selector) {
    self.options.trigger = '[data-' + selector.replace('.', '') + ']'
    self.options.panel = selector + '__panel'
    self.options.content = selector + '__content'
    self.events.click(selector)

    $(selector).each(function() {
      self.service.showInit(this)
    })
  },

  events: {
    click: function(selector) {
      $(document).on('click', selector + ' ' + self.options.trigger, function(e) {
        var trigger = e.target
        var parent = $(trigger).closest(selector)
        var panel = $(trigger).closest(self.options.panel)

        $(panel).addClass('activating')

        if ($(this).hasClass('disable') || $(panel).hasClass('active') && $(this).hasClass('disable-on-active')) {
          return
        }

        if ($(parent).data('exclusive')) {
          self.service.hideAll(parent)
        }

        if ($(panel).hasClass('active')) {
          self.service.hide(panel, this)
        } else {
          self.service.show(panel, this)
        }

        e.preventDefault() // Prevent default action of button
      })
    }
  },

  service: {
    showInit: function(parent) {
      var panels = $(parent).find(self.options.panel)

      $(panels).each(function(){
        if ($(this).hasClass('active')) {
          var panel = $(this)
          var target = $(panel).find(self.options.content)

          $(target).not(':animated').slideDown(100)
        }
      })
    },

    hideAll: function(parent) {
      var panels = $(parent).find(self.options.panel)

      $(panels).each(function(){
        if (!$(this).hasClass('activating')) {
          var panel = $(this)
          var target = $(panel).find(self.options.content)

          $(panel).removeClass('active')
          $(target).not(':animated').slideUp(100)
        }
      })
    },

    hide: function(parent, link) {
      var target = $(link).data('accordion') || $(link).attr('href')
      var content = $(parent).find(target)

      $(parent).removeClass('active')
      $(content).not(':animated').slideUp(100)
      $(parent).removeClass('activating')
    },

    show: function(parent, link) {
      var target = $(link).data('accordion') || $(link).attr('href')
      var content = $(parent).find(target)

      $(parent).addClass('active')
      $(content).not(':animated').slideDown(100)
      $(parent).removeClass('activating')
    }
  }
}
